<template>
  <v-content>
    <!-- PMD -->
    <v-card class="primary lighten-1 white--text">
      <!-- <v-card-title class=" headline">
        <v-icon class="icon-space" left>business</v-icon>
        <span class="ml-4 headline">{{ project.name }}</span>
      </v-card-title> -->
      <v-container fluid grid-list-sm>
      <v-layout row wrap>
      <!-- Project Info Expantion -->
        <!-- Status Info -->
        <v-flex xs12 md4>
          <v-toolbar
            class="subheading white--text"
            v-bind:class="statusStyle"
            dense
            >
            <v-icon class="white--text">comment</v-icon>
            <span class="ml-3">{{project.updateTimestamp}}</span>
            <v-spacer></v-spacer>
            <v-btn
                v-if="!editUpdateOpen"
                icon
                small
                right
                flat
                round
                @click="editUpdateOpen = true"
                >
                <v-icon class="white--text">add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list class="primary lighten-1 white--text" two-line v-if="!editUpdateOpen">
            <v-list-item >
              <v-list-item-content>
                <v-list-item-title >
                  Update
                </v-list-item-title>
                <v-list-item-sub-title class="update-text">
                  {{ project.updateText }}                                            
                </v-list-item-sub-title>
                <!-- <v-list-item-sub-title>
                  Toggl Project ID: {{ project.id }}
                </v-list-item-sub-title> -->
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card v-if="editUpdateOpen">
            <v-card-text>
              New Update Date: {{ todaysDate }}
              <v-form>
                <v-select
                  v-bind:items="projectStatuses"
                  v-model="project.updateStatus"
                  label="New Project Update Status"
                  required
                ></v-select>
              </v-form>
              <v-text-field
                label="New Project Update Text"
                v-model="project.updateText"
                multi-line
              ></v-text-field>
              <v-card-actions>
                <!-- Buttons -->
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  class="hidden-xs-only"
                  @click=" editUpdateOpen = false"
                >Cancel
                </v-btn>
                <v-btn
                  flat
                  class="hidden-xs-only"
                  @click="pushProjectUpdate(); editUpdateOpen = false"
                >Save
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-flex>


        <!-- Company Info -->
        <v-flex xs12 md4>
                <v-toolbar
                    class=" subheading"
                    v-bind:class="statusStyle"
                    dense
                    >
                    <v-icon class="white--text">business</v-icon>
                    <span class="ml-3"></span>
                    <v-spacer></v-spacer>

                </v-toolbar>

            <v-list class="primary lighten-1 white--text" three-line>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">
                            {{ project.cName }}
                        </v-list-item-title>
                        <v-list-item-title class="subtitle">
                            {{ project.name }}
                        </v-list-item-title>
                        <v-list-item-sub-title>
                            Toggl Client ID: {{ project.cid }}                                            
                        </v-list-item-sub-title>
                        <v-list-item-sub-title>
                            Toggl Project ID: {{ project.id }}                                            
                        </v-list-item-sub-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-flex>

        <!-- Lead Card -->




        <v-flex xs12 md4>
                <v-toolbar
                    class=" subheading"
                    v-bind:class="statusStyle"
                    dense
                    >
                    <v-icon class="white--text">account_box</v-icon>
                    <span class="ml-3"></span>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="!editLeadOpen"
                        small
                        icon
                        right
                        flat
                        @click="editLeadOpen = true"
                        >
                        <v-icon class="white--text">mode_edit</v-icon>
                    </v-btn>
                </v-toolbar>

            <v-list class="primary lighten-1 white--text" one-line v-if="!editLeadOpen">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">
                            {{ project.leadName }}
                            <v-list-item-action>

                            </v-list-item-action>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
                <!-- Lead Form -->
                <v-card v-if="editLeadOpen">
                    <v-card-text>
                        <v-form>
                        <v-select
                        v-bind:items="peopleEmails"
                        v-model="project.leadName"
                        label="Project Lead"
                        required
                        ></v-select>
                        </v-form>
                    </v-card-text>
                    <!-- Buttons -->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        flat
                        
                        class="hidden-xs-only"
                        @click="editLeadOpen = false"
                        >
                        Cancel
                        </v-btn>
                        <v-btn
                        flat
                        class="hidden-xs-only"
                        @click="updateProjectLead(); editLeadOpen = false"
                        :disabled="false"
                        >
                        Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
        </v-flex>
        <v-flex xs12 md4>
        </v-flex>
      </v-layout>
    </v-container>
    </v-card>
  </v-content>
</template>

<script>
import store from "@/store/";
import {
  projectManagementDetailsViewRef,
  administratorsRef,
  peopleRef,
  projectsLeadsRef,
  projectsUpdatesRef
} from "@/vue-service-database";

export default {
  firebase: {
    projectsManagementDetailsView: projectManagementDetailsViewRef
  },
  computed: {
    selectedProjectKey() {
      return this.$store.getters.selectedProjectKey;
    },
    projectsManagementDetails() {
      return this.$store.getters.projectsManagementDetails;
    },
    project() {
      return this.$store.getters.project;
    },
    peopleEmails() {
      let people = this.$store.getters.people;
      let emails = [];
      for (let person in people) {
        emails.push(people[person].email);
      }
      return emails;
    },
    statusStyle() {
      let project = this.$store.getters.project;
      if (project.updateStatus == "3 - green") {
        return { "light-green darken-2": true };
      } else if (project.updateStatus == "2 - yellow") {
        return { "amber darken-1": true };
      } else if (project.updateStatus == "1 - red") {
        return { "red darken-2": true };
      } else {
        return { grey: true };
      }
    },
    todaysDate() {
      let currentDate = new Date();
      return currentDate.toLocaleDateString("en-US");
    }
  },
  methods: {
    updateProjectLead() {
      projectsLeadsRef.once("value", snapshot => {
        let projectsLeads = snapshot.val();
        let newLeadProps = {
          id: this.project.id,
          leadName: this.project.leadName
        };
        let isNew = true;
        for (let key in projectsLeads) {
          if (projectsLeads[key].id == this.project.id) {
            isNew = false;
            projectsLeadsRef.child(key).update(newLeadProps);
          }
        }
        if (isNew) {
          projectsLeadsRef.push(newLeadProps);
        }
      });
    },
    pushProjectUpdate() {
      let update = {
        id: this.project.id,
        updateTimestamp: this.todaysDate,
        updateText: this.project.updateText,
        updateStatus: this.project.updateStatus
      };
      projectsUpdatesRef.push(update);
    }
  },
  data() {
    return {
      editProjectOpen: false,
      editStatusOpen: false,
      projectStatuses: ["3 - green", "2 - yellow", "1 - red"],
      editLeadOpen: false,
      editUpdateOpen: false,
      projectStatusGreen: false,
      projectStatusYellow: false,
      projectStatusRed: false,
      headersProject: [
        {
          text: "Updated On",
          align: "left",
          sortable: true,
          value: "updateTimestamp"
        },
        {
          text: "Update Details",
          align: "left",
          sortable: false,
          value: "updateText"
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "updateStatus"
        }
      ]
    };
  }
};
</script>

<style >
/* style the userImage to fit in nav */
.update-text {
  max-width: 600px;
}
</style>




// WEBPACK FOOTER //
// src/components/Projects/Project.vue